import axios from "axios";
import Constants from "../../../components.constants.js"
const CancelToken = axios.CancelToken;
let currentXhrOngoingRequest = null;
const REQUEST_CANCELLED_MSG = "REQUEST_CANCELLED_BY_FUSION";
export default {
  async getAllAssetsFromServer(context, payload = {}) {
    try{
      if(currentXhrOngoingRequest) {
        console.log("XHR request cancelled.");
        currentXhrOngoingRequest.cancel(REQUEST_CANCELLED_MSG);
      }
    }catch(e){console.log(e)}
    currentXhrOngoingRequest = CancelToken.source();
    let url = Constants.assetsUrl;
    if(payload.nlp_search){
      url = Constants.nlpAssetsUrl
    }
    try {
      let resp = await axios.get(`${url}`, {
        ...payload,
        cancelToken: currentXhrOngoingRequest.token
      });
      if (resp.status == 200) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getAllAssetsFromServer][Store][Error occured while getting Assetslist--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      if(error && Object.prototype.hasOwnProperty.call(error,'message')  && String(error.message).includes(REQUEST_CANCELLED_MSG)){
        return REQUEST_CANCELLED_MSG;
      }
      return {}
    }
  },
  async getAutoCompletedAssetsFromServer(context, payload = {}) {

    try {
      let resp = await axios.get(`${Constants.assetsAutoCompleteUrl}`, payload);
      if (resp.status == 200) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[assetsAutoCompleteUrl][Store][Error occured while getting Assetslist--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  async getCatalogAssetsCountFromServer(context, payload = {}) {
    try {
      let resp = await axios.get(`${Constants.catalogAssetsCount}/${payload.params.catalog_id}`, payload);
      if (resp.status == 200) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getCatalogAssetsCountFromServer][Store][Error occured while getting assets count--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  async addNewCategory(context, payload = {}) {
    //payload : FUSION Users JSON schema

    try {
        let resp = await axios.post(Constants.categoriesUrl, payload);
        if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
                `[addNewCategory][Store][Category add resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
        } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
    } catch (error) {
        console.error(
            `[addNewCategory][Store][Error occured while adding Category--->${error}]`
        );
        if (error.response) {
            if (error.response.status == 401) {
                return context.dispatch("users/logOutFromServer", {}, { root: true })
            } else {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
        }
        return {}
    }

  },
  async addPhotoAlbum(context, payload = {}) {
    try {
        let resp = await axios.post(Constants.photoAlbumUrl, payload);
        if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
                `[addPhotoAlbum][Store][Category add resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
        } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
    } catch (error) {
        console.error(
            `[addPhotoAlbum][Store][Error occured while adding photo album--->${error}]`
        );
        if (error.response) {
            if (error.response.status == 401) {
                return context.dispatch("users/logOutFromServer", {}, { root: true })
            } else {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
        }
        return {}
    }
  },
  async addAssetPackage(context, payload = {}) {
    try {
        let resp = await axios.post(Constants.packageUrl, payload);
        if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
                `[addAssetPackage][Store][Package add resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
        } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
    } catch (error) {
        console.error(
            `[addAssetPackage][Store][Error occured while adding Package--->${error}]`
        );
        if (error.response) {
            if (error.response.status == 401) {
                return context.dispatch("users/logOutFromServer", {}, { root: true })
            } else {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
        }
        return {}
    }
  },
  async updatePhotoAlbum(context, payload = {}) {
    try {
        let resp = await axios.put(`${Constants.assetsUrl}/${payload.params._id}`, payload);
        if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
                `[updatePhotoAlbum][Store][Category add resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
        } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
    } catch (error) {
        console.error(
            `[updatePhotoAlbum][Store][Error occured while updating photo album--->${error}]`
        );
        if (error.response) {
            if (error.response.status == 401) {
                return context.dispatch("users/logOutFromServer", {}, { root: true })
            } else {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
        }
        return {}
    }
  },
  async updateCatalogAsPhotoAlbum(context, payload = {}) {
      try {
          let resp = await axios.put(`${Constants.photoAlbumUrl}/${payload.params._id}`, payload);
          if (Constants.acceptedStatusCodes.includes(resp.status)) {
              console.log(
                  `[updateCatalogAsPhotoAlbum][Store][Resp-->${resp.status}]`
              );
              resp.data.statusCode = resp.status
              return resp.data;
          } else {
              throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
      } catch (error) {
          console.error(
              `[updateCatalogAsPhotoAlbum][Store][Error occured while settings catalog as photo album--->${error}]`
          );
          if (error.response) {
              if (error.response.status == 401) {
                  return context.dispatch("users/logOutFromServer", {}, { root: true })
              } else {
                  error.response.data.statusCode = error.response.status
                  return error.response.data
              }
          }
          return {}
      }
  },
  async addAssetsPhotoAlbum(context, payload = {}) {
      try {
          let resp = await axios.put(`${Constants.photoAlbumUrl}/assets/${payload.params._id}`, payload);
          if (Constants.acceptedStatusCodes.includes(resp.status)) {
              console.log(
                  `[addAssetsPhotoAlbum][Store][Category add resp-->${resp.status}]`
              );
              resp.data.statusCode = resp.status
              return resp.data;
          } else {
              throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
          }
      } catch (error) {
          console.error(
              `[addAssetsPhotoAlbum][Store][Error occured while adding photos to photo album--->${error}]`
          );
          if (error.response) {
              if (error.response.status == 401) {
                  return context.dispatch("users/logOutFromServer", {}, { root: true })
              } else {
                  error.response.data.statusCode = error.response.status
                  return error.response.data
              }
          }
          return {}
      }
  },
  async addAssetsPackage(context, payload = {}) {
    try {
        let resp = await axios.put(`${Constants.packageUrl}/assets/${payload.params._id}`, payload);
        if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
                `[addAssetsPackage][Store][Package add resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
        } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
    } catch (error) {
        console.error(
            `[addAssetsPackage][Store][Error occured while adding photos to package--->${error}]`
        );
        if (error.response) {
            if (error.response.status == 401) {
                return context.dispatch("users/logOutFromServer", {}, { root: true })
            } else {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
        }
        return {}
    }
  },
  async downloadAssetsReportFromServer(context,payload={}){
    try {
      let resp = await axios.get(Constants.assetsReportUrl, payload);
      if (resp.status == 200) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
  } catch (error) {
      console.error(
          `[downloadAssetsReportFromServer][Store][Error occured while downloading assets reports --->${error}]`
      );
      if (error.response) {
          if (error.response.status == 401) {
              return context.dispatch("users/logOutFromServer", {}, { root: true })
          } else {
              error.response.data.statusCode = error.response.status
              return error.response.data
          }
      }
      return ''
    }
  },
  async exportFilesToOutbox(context, payload ={}){
    try {
        let resp = await axios.put(`${Constants.outboxUrl}/${payload.params.user_id}`, payload);
        if (resp.status == 200) {
          resp.data.statusCode = resp.status
          return resp.data;
        } else {
          throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
    } catch (error) {
        console.error(
            `[exportFilesToOutbox][Store][Error occured while exporting assets to outbox --->${error}]`
        );
        if (error.response) {
          if (error.response.status == 401) {
              return context.dispatch("users/logOutFromServer", {}, { root: true })
          } else {
              error.response.data.statusCode = error.response.status
              return error.response.data
          }
        }
        return ''
    }
  },
  
  async getCategoryTreefromId(context, payload = {}) {

    try {
        let resp = await axios.get(`${Constants.categoriesUrl}/${payload.params.categoryId}`);
        if (Constants.acceptedStatusCodes.includes(resp.status)) {
            let assetData = resp.data['assets'][0]
            let route = assetData['catalog_name']
            let pid = assetData["parent_id_path"][0]
            while (pid != Constants.rootCategory) {
                let categoryInfo = await axios.get(`${Constants.categoriesUrl}/${pid}`);
                let catAssetData = categoryInfo.data['assets'][0];
                route = `${catAssetData['cataog_name']} > ${route}`
                pid = catAssetData["parent_id_path"][0]
            }
            return route
        } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
    } catch (error) {
        console.error(
            `[getCategoryTreefromId][Store][Error occured while getting Category info --->${error}]`
        );
        if (error.response) {
            if (error.response.status == 401) {
                return context.dispatch("users/logOutFromServer", {}, { root: true })
            } else {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
        }
        return ''
      }
  },
  async updateAssetsLink(context, payload = {}) {
    try {
      let resp = await axios.put(Constants.assetsLinkUrl, payload);
      if (resp.status == 200) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[updateAssetsLink][Store][Error occured while updating asset links--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  async getAssetInfoFromServer(context, payload = {}) {
    //payload : {params:{assetId:"3422344231"}}

    try {
      let assetId = payload.params.assetId
      delete payload.params.assetId
      let resp = await axios.get(`${Constants.assetsUrl}/${assetId}`, payload);
      if (resp.status == 200) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getAssetInfoFromServer][Store][Error occured while getting asset info--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  async updateAssetVersionDetails(context, payload = {}) {
    try {
      let resp = await axios.put(`${Constants.assetVersionUpdateUrl}/${payload.params.asset_id}`, payload);
      if (resp.status == 200) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[updateAssetVersionInfo][Store][Error occured while updating asset version info--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }else if (error.response.status == 405){
          return {statusCode:error.response.status,message:"failed to update asset version info"}
        } else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  async updateAssetLabelsInfo(context, payload = {}) {
    try {
      let resp = await axios.put(Constants.assetLabelUrl, payload);
      if (resp.status == 200) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[updateAssetLabelsInfo][Store][Error occured while updating asset labels info--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }else if (error.response.status == 405){
          return {statusCode:error.response.status,message:"failed to update file info"}
        } else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  async updateLabelsForArchiveRequest(context, payload = {}) {
    try {
      let resp = await axios.put(Constants.assetArchiveRequestUrl, payload);
      if (resp.status == 200) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[updateLabelsForArchiveRequest][Store][Error occured while updating asset Archive request labels info--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }else if (error.response.status == 405){
          return {statusCode:error.response.status,message:"failed to update file info"}
        } else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  async updateLabelsForRetrieveRequest(context, payload = {}) {
    try {
      let resp = await axios.put(Constants.assetRetrieveRequestUrl, payload);
      if (resp.status == 200) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[updateLabelsForRetrieveRequest][Store][Error occured while updating asset retrieve labels info--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }else if (error.response.status == 405){
          return {statusCode:error.response.status,message:"failed to update file info"}
        } else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  async updateLabelsForTranscoderTarget1Request(context, payload = {}) {
    try {
      let resp = await axios.put(Constants.assetTranscoderT1RequestUrl, payload);
      if (resp.status == 200) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[updateLabelsForTranscoderTarget1Request][Store][Error occured while updating asset Transcoder target-1 labels info--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }else if (error.response.status == 405){
          return {statusCode:error.response.status,message:"failed to update file info"}
        } else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  async updateLabelsForTranscoderTarget2Request(context, payload = {}) {
    try {
      let resp = await axios.put(Constants.assetTranscoderT2RequestUrl, payload);
      if (resp.status == 200) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[updateLabelsForTranscoderTarget2Request][Store][Error occured while updating asset Transcoder target-2 labels info--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }else if (error.response.status == 405){
          return {statusCode:error.response.status,message:"failed to update file info"}
        } else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  async updateAssetInfo(context, payload = {}) {
    try {
      let resp = await axios.put(`${Constants.assetsMetadataUrl}/${payload._id}`, payload);
      if (resp.status == 200) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[updateAssetInfo][Store][Error occured while updating asset metadata info--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }else if (error.response.status == 405){
          return {statusCode:error.response.status,message:"failed to update file info"}
        } else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  async insertSubClip(context, payload = {}) {
    try {
      let resp = await axios.post(`${Constants.assetsMetadataUrl}`, payload);
      if (resp.status == 200) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[updateAssetInfo][Store][Error occured while getting asset info--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }else if (error.response.status == 405){
          return {statusCode:error.response.status,message:"failed to update file info"}
        } else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  async deleteSubclip(context, payload = {}){
    try {
      let resp = await axios.delete(`${Constants.assetsMetadataUrl}/${payload._id}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
          console.log(
              `[deleteSubclip][Store][Subclip Delete resp-->${resp.status}]`
          );
          resp.data.statusCode = resp.status
          return resp.data;
      } else {
          throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
  } catch (error) {
      console.error(
          `[deleteSubclip][Store][Error occured while deleting Subclip--->${error}]`
      );
      if (error.response) {
          if (error.response.status == 401) {
              return context.dispatch("users/logOutFromServer", {}, { root: true })
          } else {
              error.response.data.statusCode = error.response.status
              return error.response.data
          }
      }
      return {}
  }
  },
  async getSubclipsFromServer(context, payload = {}) {
    //payload : {params:{assetId:"3422344231"}}

    try {
      let resp = await axios.get(`${Constants.assetsUrl}`, payload);
      if (resp.status == 200) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getSubclipsFromServer][Store][Error occured while getting asset info--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  async getCatalogStructureFromCatalogID(context, payload = {}) {
    //payload : {params:{fileId:"3422344231"}}

    try {
        let catalog_id = payload.params.catalog_id
        delete payload.params.catalog_id
        let resp = await axios.get(`${Constants.assetsUrl}/${catalog_id}/catalog-structure`, payload);
        if (resp.status == 200) {
            resp.data.statusCode = resp.status
            return resp.data;
        } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
    } catch (error) {
        console.error(
            `[getCatalogStructureFromCatalogID][Store][Error occured while getting file info--->${error}]`
        );
        if (error.response) {
            if (error.response.status == 401) {
                return context.dispatch("users/logOutFromServer", {}, { root: true })
            } else if (error.response.status == 405) {
                return { statusCode: error.response.status, message: "failed to update file info" }
            } else {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
        }
        return {}
    }
  },

  
  async getVersionInfoFromServer(context, payload = {}) {
    //payload : {params:{assetId:"3422344231"}}

    try {
      let assetId = payload.params.assetId
      delete payload.params.assetId
      let resp = await axios.get(`${Constants.assetsUrl}/${assetId}/version-info`, payload);
      if (resp.status == 200) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getVersionInfoFromServer][Store][Error occured while getting asset info--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  // ************************ Asset Link Types ********************************* //
  async getAssetLinkTypesFromServer(context, payload = {}) {
    //payload : {params:{name:"Clone"}}

    try {
      let resp = await axios.get(Constants.assetLinkTypesUrl, payload);
      if (resp.status == 200) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getAssetLinkTypesFromServer][Store][Error occured while getting asset link types info--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  async isLinkAttachedToAnyAsset(context, payload = {}) {
    //payload : {params:{name:"Clone"}}

    try {
      let resp = await axios.get(`${Constants.linkConfirmationUrl}/${payload._id}`, payload);
      if (resp.status == 200) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[isLinkAttachedToAnyAsset][Store][Error occured while getting asset link types confirmation--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },
  async addAssetLinkType(context, payload = {}){
    try {
      let resp = await axios.post(Constants.assetLinkTypesUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
          resp.data.statusCode = resp.status
          return resp.data;
      } else {
          throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
        console.error(
            `[addAssetLinkType][Store][Error occured while adding asset link type--->${error}]`
        );
        if (error.response) {
            if (error.response.status == 401) {
                return context.dispatch("users/logOutFromServer", {}, { root: true })
            } else {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
        }
        return {}
    }
  },async updateAssetLinkType(context, payload = {}){
    try {
      let resp = await axios.put(`${Constants.assetLinkTypesUrl}/${payload._id}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
          resp.data.statusCode = resp.status
          return resp.data;
      } else {
          throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
        console.error(
            `[updateAssetLinkType][Store][Error occured while updating asset link type--->${error}]`
        );
        if (error.response) {
            if (error.response.status == 401) {
                return context.dispatch("users/logOutFromServer", {}, { root: true })
            } else {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
        }
        return {}
    }
  },
  async deleteAssetLinkType(context, payload = {}){
    try {
      let resp = await axios.delete(`${Constants.assetLinkTypesUrl}/${payload._id}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
          resp.data.statusCode = resp.status
          return resp.data;
      } else {
          throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
        console.error(
            `[deleteAssetLinkType][Store][Error occured while deleting asset link type--->${error}]`
        );
        if (error.response) {
            if (error.response.status == 401) {
                return context.dispatch("users/logOutFromServer", {}, { root: true })
            } else {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
        }
        return {}
    }
  },
  // ************************ *************** ********************************* //

  /**
   *   Asset annotation related
   */

  async addAssetsAnnotationWithComments(context, payload = {}) {
  
    try {
        let resp = await axios.post(Constants.assetAnnotationURL, payload);
        if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
                `[addAssetsAnnotationWithComments][Store][Category add resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
        } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
    } catch (error) {
        console.error(
            `[addAssetsAnnotationWithComments][Store][Error occured while adding Category--->${error}]`
        );
        if (error.response) {
            if (error.response.status == 401) {
                return context.dispatch("users/logOutFromServer", {}, { root: true })
            } else {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
        }
        return {}
    }

  },

  async getAssetsAnnotationWithComments(context, payload = {}) {
  
    try {
      let resp = await axios.get(`${Constants.assetAnnotationURL}`, payload);
      if (resp.status == 200) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getAssetsAnnotationWithComments][Store][Error occured while getting annotation data and message--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async updateAssetsAnnotationWithComments(context, payload = {}){
    try {
      let commentId = payload.commentId;
      delete payload.commentId;
      let resp = await axios.put(`${Constants.assetAnnotationURL}/${commentId}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
          resp.data.statusCode = resp.status
          return resp.data;
      } else {
          throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
        console.error(
            `[updateAssetsAnnotationWithComments][Store][Error occured while updating annotation--->${error}]`
        );
        if (error.response) {
            if (error.response.status == 401) {
                return context.dispatch("users/logOutFromServer", {}, { root: true })
            } else {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
        }
        return {}
    }
  },

  /**
   *   End of asset annotation
   */

  async getAssetReportsData(context, payload = {}) {
    try{
      if(currentXhrOngoingRequest) {
        console.log("XHR request cancelled.");
        currentXhrOngoingRequest.cancel(REQUEST_CANCELLED_MSG);
      }
    }catch(e){console.log(e)}
    currentXhrOngoingRequest = CancelToken.source();
    try {
      let resp = await axios.get(`${Constants.assetsReportsURL}`, {
        ...payload,
        cancelToken: currentXhrOngoingRequest.token
      });
      if (resp.status == 200) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getAssetReportsData][Store][Error occured while getting Assetslist--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      if(error && Object.prototype.hasOwnProperty.call(error,'message')  && String(error.message).includes(REQUEST_CANCELLED_MSG)){
        return REQUEST_CANCELLED_MSG;
      }
      return {}
    }
  },

  //VTR ingest (NRAA)

  async updateAssetMetadata(context, payload = {}) {
    try {
      let resp = await axios.post(`${Constants.assetCommentsUrl}`, payload);
      if (resp.status == 200) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[updateAssetInfo][Store][Error occured while getting asset info--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }else if (error.response.status == 405){
          return {statusCode:error.response.status,message:"failed to update file info"}
        } else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  /**
   *   Assests comments for growing or live stream media
   */
  async getGrowingMediaComments(context, payload = {}) {
  
    try {
      let resp = await axios.get(`${Constants.assetCommentsUrl}`, payload);
      if (resp.status == 200) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getGrowingMediaComments][Store][Error occured while getting annotation data and message--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async addGrowingMediaComment(context, payload = {}) {
  
    try {
        let resp = await axios.post(Constants.assetCommentsUrl, payload);
        if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
                `[addGrowingMediaComment][Store][Category add resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
        } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
    } catch (error) {
        console.error(
            `[addGrowingMediaComment][Store][Error occured while adding Category--->${error}]`
        );
        if (error.response) {
            if (error.response.status == 401) {
                return context.dispatch("users/logOutFromServer", {}, { root: true })
            } else {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
        }
        return {}
    }

  },

  async updateGrowingMediaComments(context, payload = {}) {
    try {
      let resp = await axios.put(`${Constants.assetCommentsUrl}/${payload.comment_id}`, payload.params);
      if (resp.status == 200) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[updateAssetInfo][Store][Error occured while getting asset info--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }else if (error.response.status == 405){
          return {statusCode:error.response.status,message:"failed to update file info"}
        } else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async exportGrowingMediaFilesAsFCPXML(context, payload = {}){
      try {
        let resp = await axios.post(`${Constants.categoriesUrl}/${payload.asset_id}/comments/adobe_export`, payload.params);
        if (Constants.acceptedStatusCodes.includes(resp.status)) {
            console.log(
                `[exportGrowingMediaFilesAsFCPXML][Store][adding growing media fcpxml  resp-->${resp.status}]`
            );
            resp.data.statusCode = resp.status
            return resp.data;
        } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
    } catch (error) {
        console.error(
            `[exportGrowingMediaFilesAsFCPXML][Store][Error occured while adding growing media fcpxml--->${error}]`
        );
        if (error.response) {
            if (error.response.status == 401) {
                return context.dispatch("users/logOutFromServer", {}, { root: true })
            } else {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
        }
        return {}
    }
  },

  async getAltoContainerStatusInProperties(context, payload = {}) {
    const fileUID = payload.fileUID;
    if (fileUID === undefined || fileUID === null || String(fileUID).trim() === "") {
      throw new Error("File UID is required to fetch ALTO container status.");
    }


    try {
        let resp = await axios.get(Constants.altoContainerStatusURL + '/' + payload.fileUID, payload.params);
        if (Constants.acceptedStatusCodes.includes(resp.status)) {
            resp.data.statusCode = resp.status
            return resp.data;
        } else {
            throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
        }
    } catch (error) {
        console.error(
            `[getAltoContainerStatusInProperties][Store][Error occured while getting ALTO container status--->${error}]`
        );
        if (error.response) {
            if (error.response.status == 401) {
                return context.dispatch("users/logOutFromServer", {}, { root: true })
            } else {
                error.response.data.statusCode = error.response.status
                return error.response.data
            }
        }
        return {}
    }
  },  
};
